import { NumberField } from "features/WorklistTools/shared/components/NumberField";
import { useAppReduxDispatch } from "hooks/reduxHooks";
import {
  DestPlateInfoState,
  DestPlateStringKeys,
  ExternalThawToolActions,
} from "../../state";

interface TopUpVolProps {
  destPlateInfo: DestPlateInfoState;
  pelletResuspensionVol: number | null;
  operatingVol: number;
  minOperatingVol: number;
}

export const TopUpVol = ({
  destPlateInfo,
  pelletResuspensionVol,
  operatingVol,
  minOperatingVol,
}: TopUpVolProps) => {
  const dispatch = useAppReduxDispatch();

  const handleDestPlateSettingsChanged = (
    index: number,
    key: DestPlateStringKeys,
    value: string | number | boolean
  ) => {
    dispatch(
      ExternalThawToolActions.UPDATE_DESTINATION_PLATE_INFO({
        index,
        key,
        value,
      })
    );
  };

  const getErrorMessage = () => {
    if (destPlateInfo.labwareTypeCode === "") {
      return "";
    }
    if (destPlateInfo.topUpVol === 0) {
      return "Top Up Volume can't be 0";
    }
    if (isNaN(destPlateInfo.topUpVol)) {
      return "Top Up Volume can't be empty";
    }
    if (destPlateInfo.topUpVol < destPlateInfo.minOperatingVol) {
      return `Cannot be less than ${destPlateInfo.minOperatingVol}µL`;
    }
    return "";
  };

  return (
    <>
      <NumberField
        size="small"
        id="top-up-vol"
        style={{ width: "45%", marginRight: "15px" }}
        label={"Target Final Well Volume (Topup)"}
        value={destPlateInfo.topUpVol}
        onChange={(value) => {
          handleDestPlateSettingsChanged(
            destPlateInfo.index,
            "topUpVol",
            parseInt(value)
          );
        }}
        minValue={minOperatingVol}
        maxValue={operatingVol}
        hasError={!!getErrorMessage()}
        errorMessage={getErrorMessage()}
      />
    </>
  );
};
